export const serverUrl = process.env.REACT_APP_SERVER_URL;
